import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Header = ({ title, breadcrumbs, onMenuToggle }) => {
  const navigate = useNavigate();
  const { user, canEdit, isAuditor } = useAuth();

  return (
    <header className="admin-header">
      {/* Left: menu toggle + title */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button
          type="button"
          className="header-icon-btn d-md-none"
          onClick={onMenuToggle}
          aria-label="القائمة"
        >
          <i className="bi bi-list" style={{ fontSize: '1.1rem' }}></i>
        </button>

        <div>
          {breadcrumbs && breadcrumbs.length > 0 && (
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb" style={{ fontSize: '0.75rem', marginBottom: 2 }}>
                {breadcrumbs.map((crumb, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item${index === breadcrumbs.length - 1 ? ' active' : ''}`}
                    onClick={() => crumb.path && navigate(crumb.path)}
                    style={{ cursor: crumb.path ? 'pointer' : 'default' }}
                  >
                    {crumb.icon && <i className={`${crumb.icon} ms-1`}></i>}
                    {crumb.label}
                  </li>
                ))}
              </ol>
            </nav>
          )}
          <h1 className="header-title">{title}</h1>
        </div>
      </div>

      {/* Right: actions + user */}
      <div className="header-actions">
        <button className="header-icon-btn" title="الإشعارات" type="button">
          <i className="bi bi-bell"></i>
        </button>
        <button className="header-icon-btn" title="الرسائل" type="button">
          <i className="bi bi-envelope"></i>
        </button>

        <div className="header-user-badge d-none d-sm-flex">
          <div className="header-user-avatar">
            <i className="bi bi-person-fill"></i>
          </div>
          <span>{user?.username || user?.email || 'المدير'}</span>
          {(canEdit || isAuditor) && (
            <span
              className={`badge ${canEdit ? 'bg-success' : 'bg-warning text-dark'}`}
              style={{ fontSize: '0.6rem', padding: '3px 7px' }}
            >
              {canEdit ? 'Admin' : 'Auditor'}
            </span>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
